// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__24u1A","error":"InputSecondary_error__3MfH_","disabled":"InputSecondary_disabled__wjdcK"};